<template>
  <div class="page">
    <div class="listContentLayout">
      <div class="banner">
        <img src="./assets/img/banner.png" alt="" />
      </div>
      <div class="stat-box">
        <div class="title">自有订单</div>
        <div class="el">
          <div class="num">
            <span class="price">{{ statData.num || 0 }}</span>
          </div>
          <div class="label">有效订单数</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData.sumTotal || 0 }}</span>
          </div>
          <div class="label">订单金额</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData.sumNeedPay || 0 }}</span>
          </div>
          <div class="label">需要支付</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData.sumPaid || 0 }}</span>
          </div>
          <div class="label">已经支付</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData.sumRefund || 0 }}</span>
          </div>
          <div class="label">已退款</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{
              ((statData.sumTotal || 0) - (statData.sumPaid || 0)).toFixed(1)
            }}</span>
          </div>
          <div class="label">未收账款</div>
        </div>
      </div>
      <div
        class="bar"
        style="height: 0.11rem; background: #f2f1f6; width: 100%"
      ></div>
      <div class="stat-box box1">
        <div class="title">来自尚道的订单</div>
        <div class="el">
          <div class="num">
            <!-- <span class="fu">￥</span> -->
            <span class="price">{{ statData1.num || 0 }}</span>
          </div>
          <div class="label">有效订单数</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData1.sumTotal || 0 }}</span>
          </div>
          <div class="label">订单金额</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData1.sumNeedPay || 0 }}</span>
          </div>
          <div class="label">需要支付</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData1.sumPaid || 0 }}</span>
          </div>
          <div class="label">已经支付</div>
        </div>
        <div class="el">
          <div class="num">
            <span class="fu">￥</span>
            <span class="price">{{ statData1.sumRefund || 0 }}</span>
          </div>
          <div class="label">已退款</div>
        </div>
        <!-- <div class="el">
            <div class="num">
              <span class="fu">￥</span>
              <span class="price">{{(statData1.sumTotal - statData1.sumPaid).toFixed(1)}}</span>
            </div>
            <div class="label">未收账款</div>
          </div> -->
      </div>
      <div
        class="bar"
        style="height: 0.11rem; background: #f2f1f6; width: 100%"
      ></div>
      <div class="six-box">
        <div class="title">我的功能</div>
        <div
          class="item"
          style="border-right: 0; border-bottom: 0"
          @click="onClickItem(1)"
        >
          <img src="./assets/img/1.png" alt="" />
          <span>最新订单</span>
        </div>
        <div
          class="item"
          style="border-right: 0; border-bottom: 0"
          @click="onClickItem(2)"
        >
          <img src="./assets/img/2.png" alt="" />
          <span>线路订单</span>
          <!-- <span>查看订单</span> -->
        </div>
        <div class="item" style="border-bottom: 0" @click="onClickItem(3)">
          <img src="./assets/img/3.png" alt="" />
          <span>组团方订单</span>
          <!-- <span>查看订单</span> -->
        </div>
        <div
          class="item"
          style="border-right: 0; border-bottom: 0"
          @click="onClickItem(4)"
        >
          <img src="./assets/img/4.png" alt="" />
          <span>系统消息</span>
        </div>
        <div class="item" style="border-right: 0" @click="onClickItem(5)">
          <img src="./assets/img/5.png" alt="" />
          <span>线路分享明细</span>
        </div>
        <div class="item" @click="onClickItem(6)">
          <img src="./assets/img/6.png" alt="" />
          <span>组团方管理</span>
        </div>
        <div class="item" @click="onClickItem(7)">
          <img src="./assets/img/7.png" alt="" />
          <span>邀请组团社</span>
        </div>
        <div
          class="item"
          @click="onClickItem(8)"
          style="margin-right: auto; border-top: 0; border-left: 0"
        >
          <img src="./assets/img/8.png" alt="" />
          <span>计调</span>
        </div>
        <div
          class="item"
          style="border-right: 0; border-bottom: 0"
          @click="onClickItem(9)"
        >
          <img src="../saler/assets/img/1.png" alt="" />
          <span>报帐</span>
        </div>
        <div
          class="item"
          style="border-right: 0; border-bottom: 0"
          @click="onClickItem(10)"
        >
          <img src="../saler/assets/img/2.png" alt="" />
          <span>代收登记</span>
        </div>
        <div
          class="item"
          style="border-right: 0; border-bottom: 0"
          @click="onClickItem(11)"
        >
          <img src="../saler/assets/img/3.png" alt="" />
          <span>录入客单</span>
        </div>
      </div>
      <div class="logout">
        <div class="btn" @click="logOut()">退出登录</div>
      </div>
    </div>
    <yd-popup
      v-model="showQrCode"
      position="center"
      width="300px"
      masker-opacity="0.88"
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <div
          class="title"
          style="color: #fff; font-size: 14px; text-align: center; height: 25px"
        >
          通过微信发送二维码给组团方
        </div>
        <div
          class="title"
          style="color: #fff; font-size: 14px; text-align: center; height: 25px"
        >
          组团方在微信里填写信息提交后即可查看供应价
        </div>
        <div
          class="title"
          style="color: #fff; font-size: 14px; text-align: center; height: 25px"
        >
          组团方可通过活动帖子直接预定排期和占位
        </div>
        <div
          class="qrCodeBackLayout"
          style="
            display: flex;
            justify-content: center;
            background: #fff;
            height: 224px;
            width: 224px;
            align-items: center;
          "
        >
          <div id="qrcode" ref="qrcode"></div>
        </div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import appService from "@/services/request/appService";
import wechatService from "@/services/request/wechatService";
import store from "store";
import QRCode from "qrcodejs2";
import { Dialog } from "vant";
export default {
  name: "BigDataIndex",
  components: {
    Dialog,
  },
  data() {
    return {
      mine: {},
      startDate: "",
      statData: {},
      statData1: {},
      selectedFromDate: "",
      selectedToDate: "",
      firstLoadEnd: false,
      itemList: [],
      width: 0,
      showQrCode: false,
      user: {},
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      document.title = "管理中心";
      this.wechatInit(() => {
        console.log("user", this.user);
        this.getUserPermissionScope();
      });
      this.getStat();
    });
  },
  methods: {
    logOut() {
      Dialog.confirm({
        title: "提示",
        message: "确定退出登录吗?",
      })
        .then(() => {
          // on confirm
          localStorage.clear();
          this.$router.replace({
            name: "Login",
            query: {
              iid: this.$route.query.iid
                ? this.$route.query.iid
                : this.mine.iid,
            },
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    getStat() {
      //自己的
      appService
        .getStat({
          iid: this.$route.query.iid,
          fromIid: this.$route.query.iid,
          activity_id: "",
          groupClubId: "",
          queryKey: "",
          startTime: "",
          endTime: "",
          status: "",
        })
        .then(
          (data) => {
            console.log("data", data);
            this.statData = data;
          },
          (error) => {
            this.$dialog.toast({
              mes: error.msg,
              timeout: 1500,
              icon: "error",
            });
          }
        );

      appService
        .getStat({
          iid: this.$route.query.iid,
          fromIid: 1000,
          activity_id: "",
          groupClubId: "",
          queryKey: "",
          startTime: "",
          endTime: "",
          status: "",
        })
        .then(
          (data) => {
            console.log("data", data);
            this.statData1 = data;
          },
          (error) => {
            this.$dialog.toast({
              mes: error.msg,
              timeout: 1500,
              icon: "error",
            });
          }
        );
    },
    wechatInit(callback) {
      if (this.$route.query.noTab) {
        return;
      }
      if (this.isRunEnv("wechat")) {
        //在微信
        this.commonWechatInit(this, (data) => {
          this.unionId = data.unionid;
          let user = {};
          user.name = data.nickname;
          user.image = data.headimgurl;
          user.unionId = data.unionid;
          this.user = user;
          if (typeof callback === "function") callback();
        });
      } else {
        if (typeof callback === "function") callback();
      }
    },
    getUserPermissionScope(callback) {
      if (this.$page.isInWechat) {
        appService
          .getUserIdentity({
            iid: this.$route.query.iid,
            rid: 0,
            unionId: store.get("loginData")
              ? store.get("loginData").id
              : this.user.unionId,
          })
          .then(
            (data) => {
              console.log("data", data);
              if (data && data.loginName && data.loginName.length < 15) {
                this.mine.phone = data.loginName;
              }
              if (data && data.nickName) {
                this.mine.nickName = data.nickName;
              }
              if (data && data.iname) {
                this.mine.iname = data.iname;
              }
              if (data && data.permission) {
                var permissionInfo = data.permission;
                this.mine.permission = permissionInfo.op;
                this.mine.status = permissionInfo.name;
              } else {
                this.mine.noSupply = 1;
              }
              console.log("mine", this.mine);
              // store.set('mine', this.mine)

              if (
                this.mine.permission > 0 &&
                this.mine.permission != 8 &&
                this.mine.permission != 10
              ) {
              } else {
                // let url = window.location.href
                // url = url.replace(/bigdata\/\index/, "a/list")
                // window.location = url
              }
              if (typeof callback === "function") callback();
            },
            (error) => {
              var errorStr = "加载失败";
              if (error && error.msg) {
                errorStr = error.msg;
              } else if (error && error.sub_msg) {
                errorStr = error.sub_msg;
              }
              this.$dialog.toast({
                mes: errorStr,
                timeout: 1500,
                icon: "error",
              });
              // store.set('mine', this.mine)
            }
          );
      } else {
        if (typeof callback === "function") callback();
      }
    },
    qrcode() {
      document.getElementById("qrcode").innerHTML = "";
      var qrUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        "/m/personal/newgroup?iid=" +
        this.$route.query.iid +
        "&code=" +
        this.verifyCode +
        "&iname=" +
        (store.get("loginData").nickname || this.mine.iname) +
        "&saleUserId=" +
        store.get("loginData").id;
      console.log("qrUrl", qrUrl);
      let qrcode = new QRCode("qrcode", {
        width: 200,
        height: 200,
        text: qrUrl,
      });
    },
    scanQrCodeAddGroup() {
      appService
        .getNewGroupClubCode({
          iid: this.$route.query.iid,
          unionId: store.get("loginData")
            ? store.get("loginData").id
            : this.user.unionId,
          saleIid: this.$route.query.saleIid ? this.$route.query.saleIid : "",
        })
        .then(
          (data) => {
            this.verifyCode = data;
            this.showQrCode = true;
            this.qrcode();
          },
          (error) => {
            var errorStr = "生成二维码失败";
            if (error && error.sub_msg) {
              errorStr = error.sub_msg;
            } else if (error && error.msg) {
              errorStr = error.msg;
            }
            this.$dialog.toast({
              mes: errorStr,
              timeout: 1500,
              icon: "error",
            });
          }
        );
    },
    onClickItem(index) {
      if (index == 1) {
        this.$router.push({
          path: "/m/bigdata/list",
          query: {
            index: index,
            iid: this.$route.query.iid,
          },
        });
      }
      if (index == 2) {
        this.$router.push({
          path: "/m/bigactdata/list",
          query: {
            index: index,
            iid: this.$route.query.iid,
          },
        });
      }

      if (index == 3) {
        this.$router.push({
          path: "/m/biggroupdata/list",
          query: {
            index: index,
            iid: this.$route.query.iid,
          },
        });
      }
      if (index == 4) {
        this.$router.push({
          name: "PersonalMessage",
          query: {
            index: index,
            iid: this.$route.query.iid,
          },
        });
      }
      if (index == 5) {
        this.$router.push({
          path: "/m/bigsharedata/list",
          query: {
            index: index,
            iid: this.$route.query.iid,
          },
        });
      }
      if (index == 6) {
        this.$router.push({
          path: "/m/personal/tour",
          query: {
            iid: this.$route.query.iid,
          },
        });
      }
      if (index == 7) {
        this.scanQrCodeAddGroup();
      }
      if (index == 8) {
        this.$router.push({
          name: "ScheduleIndex",
          query: {
            iid: this.$route.query.iid,
            noTab: 1,
            needBack: 1,
          },
        });
      }
      if (index == 9) {
        this.$router.push({
          name: "SalerIndexBills",
          query: {
            iid: this.$route.query.iid,
          },
        });
      }
      if (index == 10) {
        this.$router.push({
          name: "SalerIndexCashInInstead",
          query: {
            index: index,
            iid: this.$route.query.iid,
          },
        });
      }

      if (index == 11) {
        this.$router.push({
          name: "SalerIndexCustomerInset",
          query: {
            index: index,
            iid: this.$route.query.iid,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.page {
  font-size: 0.24rem;
}
.stat-box {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0.29rem;
  box-sizing: border-box;
  &.box1 {
    .el {
      .num {
        color: rgba(140, 148, 255, 1);
      }
    }
  }
  .title {
    width: 100%;
    font-size: 0.29rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    padding: 0.29rem 0;
    padding-bottom: 0;
  }
  .el {
    width: 33.3%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    margin: 0.15rem 0;
    .num {
      color: #f8b300;
      .fu {
        font-size: 0.29rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
      }
      .price {
        font-size: 0.4rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
      }
    }
    .label {
      font-size: 0.25rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9a9a9a;
    }
  }
}
.topLayout {
  position: absolute;
  top: 0;
  width: 100%;
  height: 1rem;
}
.topLayout .calendarLayout {
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  background-color: white;
}
.listContentLayout {
  position: absolute;
  top: 0;
  width: 100%;
  bottom: 0;
  /* margin-top: 1rem; */
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  // display: flex;
  // flex-wrap: wrap;
  background: #fff;
  .banner {
    height: 2.63rem;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .six-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 0.29rem;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 0.29rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      padding: 0.29rem 0;
      padding-bottom: 0;
    }
  }
  .item {
    width: 25%;
    // height: 2.75rem;
    // padding: 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // border:1px solid #f1f1f1;
    font-size: 14px;
    // margin-right: auto;
    margin: 0.2rem 0;
    img {
      width: 0.83rem;
      height: 0.83rem;
      margin-bottom: 10px;
    }
    span {
      font-size: 0.22rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
  .logout {
    width: 100%;
    padding: 0.4rem;
    background: #fff;
    padding-top: 0;
    margin-top: 0.5rem;
    .btn {
      height: 0.9rem;
      border: 1px solid rgb(9, 187, 7);
      border-radius: 4px;
      font-size: 0.26rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgb(9, 187, 7);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.cellLayout {
  padding: 12px;
  background-color: white;
  font-size: 0.32rem;
}
.cellLayout .cellDetailLayout {
  display: flex;
  font-size: 0.24rem;
  color: #666;
  padding-top: 8px;
}
.cellLayout .cellDetailLayout p {
  width: calc(100% / 3);
}
.barlineLayout {
  height: 10px;
  background-color: #f6f6f6;
  width: 100%;
}
</style>
